module.exports = __webpack_public_path__ + "img/avatar_registro.38fedb4e.png";